import Root from './router';

export default Root;
